import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import Metrics from 'src/entities/Metrics';
import HomeComponent from './Home.component';
import HomeBanner from 'src/entities/HomeBanner';
import { GetHomeBannerAction, getHomeBanner } from 'src/actions/home-banner/get/GetHomeBanner.actions';

interface StateProps {
  metrics?: Metrics;
  homeBanner?: HomeBanner;
}

interface DispatchProps {
  getHomeBanner: () => Promise<GetHomeBannerAction>;
}

interface Props extends StateProps, DispatchProps {
}

class HomeContainer extends React.Component<Props> {

  public componentWillMount(): void {
    this.props.getHomeBanner();
  }

  public render(): React.ReactNode {
    return (
      this.props.homeBanner ?
        (
          <HomeComponent
            metrics={this.props.metrics}
            homeBanner={this.props.homeBanner}
          />
        ) :
        null
    );
  }

}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>): DispatchProps => ({
  getHomeBanner: (): Promise<GetHomeBannerAction> => (
    dispatch(getHomeBanner())
  )
});

const mapStateToProps: (state: RootState) => StateProps = (state: RootState): StateProps => ({
  homeBanner: state.getHomeBanner.homeBanner
});

export default connect(mapStateToProps, mapDispatchToProps)(HomeContainer);



// WEBPACK FOOTER //
// ./src/modules/home/Home.container.tsx